import { translate } from 'src/layouts/core-layout/_functions/translate'

export function getDialogLogout() {
  return {
    isDanger: true,
    title: translate('Выйти из профиля?'),
    text: translate('Вы выйдете из профиля на всех устройствах'),
    closeText: translate('Отменить'),
    confirmText: translate('Выйти'),
  }
}

export function getSnackbarTownSelected() {
  return {
    message: translate('Ваш город '),
    actionText: translate('Изменить'),
  }
}

export const MEDCARD_STATUS = {
  EMPTY: 'empty',
  PROTECTED: 'protected',
  NEED_CONFIRMATION: 'need_confirmation',
  EXPIRED: 'expired',
} as const

export type MedcardStatus = typeof MEDCARD_STATUS[keyof typeof MEDCARD_STATUS] | null
